import React, { useState, useEffect } from "react";
import {
  FormControl,
  TextField,
  Chip,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

export const MultiValueTextInput = ({
  value,
  onChange,
  label,
  labelValue,
  labelClasses = "",
  wrapperClasses = "",
  fieldClasses = "",
  idRef,
  placeholder,
  isDisabled,
  isSubmitted,
  helperText,
  error,
  isRequired,
  isWithError,
  themeClass = "theme-default",
  ...props
}) => {
  const [inputValue, setInputValue] = useState("");
  const [chipValues, setChipValues] = useState(
    Array.isArray(value) ? value : []
  );

  useEffect(() => {
    if (Array.isArray(value)) setChipValues(value);
  }, [value]);

  const addChip = () => {
    const val = inputValue.trim();
    if (val && !chipValues.includes(val)) {
      const newChips = [...chipValues, val];
      setChipValues(newChips);
      setInputValue("");
      if (onChange) onChange(newChips);
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if ((event.key === "Enter" || event.key === ",") && inputValue.trim()) {
      event.preventDefault();
      addChip();
    }
  };

  const handleDelete = (chipToDelete) => {
    const newChips = chipValues.filter((chip) => chip !== chipToDelete);
    setChipValues(newChips);
    if (onChange) onChange(newChips);
  };

  return (
    <FormControl
      className={`input-wrapper ${wrapperClasses} ${themeClass}`}
      fullWidth
    >
      {(labelValue || label) && (
        <label
          htmlFor={idRef}
          className={`label-wrapper ${labelClasses}${
            isDisabled ? " disabled" : ""
          }`}
        >
          {labelValue || label}
          {isRequired && <span className="asterisk">*</span>}
        </label>
      )}
      <div className="text-field-wrapper">
        <TextField
          id={idRef}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={isDisabled}
          error={isWithError ? error : undefined}
          helperText={isWithError && isSubmitted && error ? helperText : ""}
          className={`inputs ${fieldClasses}`}
          InputProps={{
            startAdornment: (
              <div
                className="chips-input-flex"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  minHeight: 32,
                  gap: 2,
                  width: '100%',
                  marginRight: 4,
                  flex: 1,
                }}
              >
                {chipValues.map((chip) => (
                  <Chip
                    key={chip}
                    label={chip}
                    onDelete={isDisabled ? undefined : () => handleDelete(chip)}
                    className="mx-1"
                    disabled={isDisabled}
                    size="small"
                    style={{ marginRight: 2, marginLeft: 2, marginBottom: 2 }}
                  />
                ))}
              </div>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="add"
                  onClick={addChip}
                  disabled={
                    isDisabled ||
                    !inputValue.trim() ||
                    chipValues.includes(inputValue.trim())
                  }
                  edge="end"
                  tabIndex={-1}
                  style={{ marginRight: 1 }}
                >
                  <AddIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          style={{ minWidth: 120, width: '100%' }}
          {...props}
        />
      </div>
      {helperText && isWithError && isSubmitted && error && (
        <div className="MuiFormHelperText-root Mui-error">{helperText}</div>
      )}
    </FormControl>
  );
};
